import { MutationTree, ActionTree, GetterTree } from "vuex";

const state = () => ({
  rateMap: {},
  showProcessOrderBtn: false,
  hasProcessOrder: false
});

export type MaketState = ReturnType<typeof state>;

const getters: GetterTree<MaketState, {}> = {
  processOrderBtnVisible(state) {
    return state.showProcessOrderBtn && state.hasProcessOrder;
  }
};

const mutations: MutationTree<MaketState> = {
  SET_RATEMAP(state, data) {
    state.rateMap = data;
  },
  SET_SHOW_PROCESS_ORDER_BTN(state, data) {
    state.showProcessOrderBtn = data;
  },
  SET_HAS_PROCESS_ORDER(state, data) {
    state.hasProcessOrder = data;
  }
};

const actions: ActionTree<MaketState, any> = {
  async loadRate({ commit }) {
    const rates = await (this as any).$api.market.getRate();
    const map = rates.reduce((acc, ticker) => {
      const currency = ticker.from.toUpperCase();
      acc[currency] = ticker.price;
      return acc;
    }, {});
    commit("SET_RATEMAP", map);
  },
  async loadProcessOrder({ state, rootGetters, commit }) {
    const isLogged = rootGetters["auth/isLogged"];
    const showProcessOrderBtn = state.showProcessOrderBtn;
    if (!isLogged || !showProcessOrderBtn) return;
    const status = ["pending", "trading", "paid"];
    const orders = await this.$api.market.getTradeOrders({
      status: status.join(","),
      limit: 10
    });
    commit("SET_HAS_PROCESS_ORDER", orders.length > 0);
  },
  async removeProcessOrder({ commit }) {
    commit("SET_HAS_PROCESS_ORDER", false);
  }
};

export default {
  namespaced: true,
  getters,
  state,
  mutations,
  actions
};
